import { render, staticRenderFns } from "./IconIntroBonus.vue?vue&type=template&id=52519160&"
import script from "./IconIntroBonus.vue?vue&type=script&lang=js&"
export * from "./IconIntroBonus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nicholashaskell/Local/kicknic/app/public/wp-content/themes/kicknic/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52519160')) {
      api.createRecord('52519160', component.options)
    } else {
      api.reload('52519160', component.options)
    }
    module.hot.accept("./IconIntroBonus.vue?vue&type=template&id=52519160&", function () {
      api.rerender('52519160', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/scripts/components/IconIntroBonus.vue"
export default component.exports